
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/migration-guide/preparing-for-migration",
      function () {
        return require("private-next-pages/events/migration-guide/preparing-for-migration.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/migration-guide/preparing-for-migration"])
      });
    }
  